import 'UI/Widget/Forms/Render/Light';
import './ObjectForm';

/** @namespace Accounting.UI */
NS('Accounting.UI');

/**
 * @class
 * @extends Accounting.UI.ObjectForm
 * @extends UI.Widget.Forms.Render.Light
 */
Accounting.UI.LightObjectForm = Class(
    Accounting.UI.ObjectForm,
    UI.Widget.Forms.Render.Light,
    /** @lends Accounting.UI.LightObjectForm.prototype */
    {
        formTemplate: "Accounting/LightObjectForm/Form",
        sourceClass: "Agronomy.Data.AccountingObjects",
        showCloseBtn: false,
        switchable: false,

        adaptive: true,

        /**
         * @param {Element} el
         * @param {Event} evt
         * @protected
         */
        onSaveClick(el, evt) {
            this.ParentCall()
                .then(item => {
                    if (!_.isEmpty(item)) {
                        this.onSaveClickSuccess(el, evt)
                    }
                });
        },
        /** @inheritDoc */
        render() {
            this.ParentCall();
            this.renderContainer();
			//this.edit();
            return this;
        }
    }
);
